export default [
    {
        path: '',
        name: 'pageHubungiKami',
        component: () => import('./page-hubungi-kami')
    }
]